module.exports = __webpack_public_path__ + "static/img/record.052785fe.png";